<template>
  <!-- 基本法管理 -->
  <div>
    <div class="tools-box">
      <div class="left-box">{{ baseInfo.name }}</div>
      <div class="right-box">
        <Button type="primary" @click="$refs.addMechanism.open(baseInfo)">新增适用机构</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="startTime">
          <span v-if="!row.edit" class="edit-box">{{ row.startTime | filterTime('YYYY/MM/DD') }}</span>
          <DatePicker
            v-else
            :disabled="row.status == 2 || row.status == 1"
            v-model="row.startTime"
            format="yyyy/MM/dd"
            type="date"
            :options="options"
            placeholder="请选择"
            style="width: 120px"
            transfer
          />
        </template>
        <template slot-scope="{ row }" slot="endTime">
          <span v-if="!row.edit" class="edit-box">{{ row.endTime | filterTime('YYYY/MM/DD') }}</span>
          <DatePicker v-else v-model="row.endTime" format="yyyy/MM/dd" type="date" :options="options" placeholder="请选择" style="width: 120px" transfer />
        </template>
        <template slot-scope="{ row }" slot="status">
          <!-- 0-未生效 1-已生效 2-已过期 -->
          <span v-if="row.status == 1">生效中</span>
          <span v-else-if="row.status == 0">未生效</span>
          <span v-else>已过期</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <!-- 0-可操作 1-已过生效期 2-已过期 -->
          <span v-if="!row.edit" class="table-btn" @click="edit(true, row, index)" :class="{ disabled: row.status == 2 || row.orgStatus != 1 }">编辑</span>
          <span v-if="row.edit" class="table-btn" @click="edit(false, row, index)">取消</span>
          <span v-if="!row.edit" @click="remove(row)" class="table-btn" :class="{ disabled: row.orgStatus != 1 || row.status != 0 }">移除</span>
          <span v-else class="table-btn" @click="saveTime(row)">保存</span>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
    <div class="tools-box right bottom-box">
      <Button type="primary" @click="$emit('next')">下一步</Button>
    </div>
    <!-- 新增适用机构 -->
    <add-mechanism ref="addMechanism" @reload="getList()"></add-mechanism>
  </div>
</template>

<script>
import addMechanism from './addMechanism';
import { pageTool, common } from '@/api/mixins';
import dayjs from 'dayjs';
export default {
  mixins: [pageTool, common],
  components: { addMechanism },
  data() {
    return {
      options: {
        disabledDate(date) {
          return dayjs(date).isBefore(new Date());
        }
      },
      baseInfo: {},
      columns: [
        {
          title: '序号',
          width: 80,
          type: 'index',
          align: 'center'
        },
        {
          title: '适用机构',
          key: 'orgName',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '开始日期',
          slot: 'startTime',
          align: 'center',
          width: 160
        },
        {
          title: '结束日期',
          slot: 'endTime',
          align: 'center',
          width: 160
        },
        {
          title: '状态',
          slot: 'status',
          align: 'center',
          width: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 110
        }
      ],
      tableData: []
    };
  },
  methods: {
    setListParams(params) {
      params.baseId = this.baseInfo.id;
    },
    init(baseInfo) {
      this.baseInfo = baseInfo;
      this.initListAjax('/buz/baseAssign/read/list');
    },
    edit(val, row) {
      this.$set(row,'edit',val);
    },
    remove(row) {
      this.$notice.inquiry('确认移除该机构？').then(() => {
        this.$http({
          url: '/buz/baseAssign/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$Message.success('操作成功');
          this.getBasicLawList();
        });
      });
    },
    /**
     *
     * @param {*} type 1开始日期 结束日期
     * @param {*} row
     */
    saveTime(row) {
      if (!row.startTime || !row.endTime) {
        return this.$Message.error(`开始时间、结束时间不能为空！`);
      }
      if (!dayjs(row.startTime).isBefore(row.endTime)) {
        return this.$Message.error(`结束时间需要大于开始时间`);
      }
      let data = {
        ...row,
        startTime: dayjs(row.startTime).format('YYYY-MM-DD'),
        endTime: dayjs(row.endTime).format('YYYY-MM-DD')
      };
      this.$notice.inquiry('是否确认修改？').then(() => {
        this.$http({
          url: '/buz/baseAssign/edit',
          type: 'POST',
          data
        }).then(res => {
          row.edit = false;
          this.$Message.success('操作成功');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
